
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
interface Dictionary<T> {
    [Key: string]: T;
}
import { RoughnessMipmapper } from "three/examples/jsm/utils/RoughnessMipmapper.js";
import Stats from 'three/examples/jsm/libs/stats.module.js';


export interface ProductInfo {
    id: number;
    product: string;
    piece: string;
    spec: string;
    file: string;
    name: string;
    type: string;
    value: string;
    description: string;
    price?: number;
    default?: number;
    lookAt?: number;
}

export interface ProductList {
    id: number;
    product: string;
    name: string;
    description: string;
    posx: number;
    posy: number;
    posz: number;
    rotx: number;
    roty: number;
    rotz: number;
    controllerMaxDistance: number;
    controllerMinDistance: number;
    camposx: number;
    camposy: number;
    camposz: number;
    camrotx: number;
    camroty: number;
    camrotz: number;
    hdr: number;
    hdrImage: number;
    normalImage: number;
    Music: number;
}


export interface PiecesInfo {
    id: number;
    uuid: string;
    product: string;
    piece: string;
    color: string;
    file: string;
    name: string;
    type: string;
    value: string;
    description: string;
    price?: number;
    default?: number;
    lookAt?: number;
}

export class RevolvaService {

    public scene: THREE.Scene;
    public controls: OrbitControls;
    public camera: THREE.PerspectiveCamera;
    public renderer: THREE.WebGLRenderer;
    public piecesInScene: Dictionary<THREE.Object3D> = {};
    public pieces: THREE.Object3D[] = [];
    public roughnessMipmapper: RoughnessMipmapper;
    public canvaId: string;
    public canvas: HTMLCanvasElement;
    public animation = false;
    public loading3D = false;
    public finishedLoading3D = true;
    public productId: number;
    public productsList: ProductList[];
    public productsInfo: ProductInfo[];
    public piecesInfo: PiecesInfo[]; 
    public canvaFullScreen = false;
    public light: THREE.DirectionalLight;
    public stats: Stats;
    public ground= false;
    public canvaHeight: number;
    public canvasWidth: number;
    public seeInside = false;
    public watchAnimation = false;
    public controlerAutoRotat = false;
    public controlerRotatOnlyOnX = false;
    public mixer: THREE.AnimationMixer;
    public clock: THREE.Clock;
    public cardranColor=1;


    constructor(
        productId: number

    ) {
        
        this.productId = productId
    }

    public destroy(): void {
        const { scene, renderer } = this;
        scene.remove()
        renderer.dispose()
    }
}

export default RevolvaService;
